import { httpGetAndParse } from '../../../utils/fetchService';

export const fetchAccountLineItemDetail = ({ taxYear, period, orgId, accountId }) =>
  httpGetAndParse({
    route: `/api/shared/account-line-item-details/${taxYear}/${period}/${orgId}/${accountId}`,
    errorMessage: 'Fetching account line item detail failed',
  });
